var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 49,
    viewBox: "0 0 55 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3334 19.5C52.3334 17.5109 51.5432 15.6032 50.1367 14.1967C48.7302 12.7902 46.8225 12 44.8334 12H39.3159C38.4678 9.01584 36.6357 6.40601 34.1173 4.59434C31.5989 2.78267 28.5419 1.87558 25.443 2.02037C22.344 2.16515 19.3849 3.35331 17.0464 5.3919C14.7078 7.43048 13.1271 10.1998 12.5609 13.25M41.0834 47H19.8334C16.5881 46.9992 13.4069 46.0959 10.6453 44.3912C7.88381 42.6865 5.65071 40.2474 4.19559 37.3466C2.74046 34.4457 2.12064 31.1974 2.40539 27.9646C2.69014 24.7318 3.86823 21.6418 5.80803 19.04C7.74782 16.4382 10.3729 14.427 13.3899 13.2312C16.4069 12.0355 19.697 11.7022 22.8925 12.2687C26.0881 12.8352 29.0631 14.2791 31.4852 16.439C33.9074 18.599 35.6812 21.39 36.6084 24.5H41.0834C42.5608 24.5 44.0237 24.791 45.3886 25.3564C46.7535 25.9217 47.9937 26.7504 49.0384 27.7951C50.083 28.8397 50.9117 30.0799 51.4771 31.4448C52.0424 32.8097 52.3334 34.2727 52.3334 35.75C52.3334 37.2274 52.0424 38.6903 51.4771 40.0552C50.9117 41.4201 50.083 42.6603 49.0384 43.705C47.9937 44.7496 46.7535 45.5783 45.3886 46.1437C44.0237 46.709 42.5608 47 41.0834 47Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus11);
export default __webpack_public_path__ + "static/media/focus1-1.340a339e7f1f78e9e72201920f9dc779.svg";
export { ForwardRef as ReactComponent };